export default "__VITE_ASSET__ByZXh8fd__"